<template>
  <div class="table">
    <el-table
      id="iTable"
      v-loading.iTable="options.loading"
      :data="list"
      :height="height"
      :stripe="options.stripe"
      ref="mutipleTable"
      :border="options.border"
      :row-key="rowKey"
      @selection-change="handleSelectionChange"
      @select="selectValue"
      @row-click="rowClick"
    >
      <el-table-column
        v-if="options.mutiSelect"
        :reserve-selection="reserve"
        :selectable="checkboxInit"
        type="selection"
        width="40px;"
        align="center"
      ></el-table-column>
      <el-table-column
        v-if="options.serialNumber"
        type="index"
        :label="$t('common.id')"
        align="center"
        :index="indexMethod"
        width="80"
      ></el-table-column>
      <template>
        <el-table-column
          v-for="(column, index) in columns"
          :key="column.label"
          :prop="column.prop"
          :label="column.label"
          :align="column.align"
          :width="column.width"
          :sortable="column.sortable"
          :fixed="column.fixed"
        >
          <template slot-scope="scope">
            <template v-if="!column.render">
              <template v-if="column.formatter">
                <span v-html="column.formatter(scope.row, column)"></span>
              </template>
              <template v-else>
                <span>{{ scope.row[column.prop] }}</span>
              </template>
            </template>
            <template v-else>
              <expand-dom
                :column="column"
                :row="scope.row"
                :render="column.render"
                :index="index"
              ></expand-dom>
            </template>
          </template>
        </el-table-column>
      </template>
      <el-table-column
        ref="fixedColumn"
        :label="$t('common.btn.operate')"
        align="center"
        :width="operates.width"
        :height="operates.height"
        :fixed="operates.fixed"
        v-if="operates.list.filter((_x) => _x.show === true).length > 0"
      >
        <template slot-scope="scope">
          <div class="operate-group">
            <template v-for="(btn, key) in operates.list">
              <div
                style="display: inline-block; margin-right: 10px"
                class="item"
                v-if="btn.show"
                :key="btn.id"
              >
                <el-button
                  :type="btn.type"
                  size="mini"
                  :icon="btn.icon"
                  :disabled="btn.disabled"
                  :plain="btn.plain"
                  @click.native.stop="btn.method(key, scope.row)"
                  >{{ btn.label }}</el-button
                >
              </div>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    rowKey: {
      type: [String, Function],
      default: () => null,
    },
    height: {
      type: [Number, String, Function],
      default: () => null,
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    reserve: {
      type: Boolean,
      default: false,
    },
    operates: {},
    options: {
      type: Object,
      default: {
        stripe: false,
        border: false,
        highlightCurrentRow: false,
      },
    },
  },

  components: {
    expandDom: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
          type: Object,
          default: null,
        },
      },
      render: (h, ctx) => {
        const params = {
          row: ctx.props.row,
          index: ctx.props.index,
        };
        if (ctx.props.column) params.column = ctx.props.column;
        return ctx.props.render(h, params);
      },
    },
  },

  data() {
    return {
      pageIndex: 1,
      multipleSelection: [],
      dtatus: "",
      Selection: {},
    };
  },
  computed: {},
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("handleSelectionChange", val);
    },
    selectValue(selection, row) {
      this.Selection = row;
      this.$emit("selectValue", selection, row);
    },
    rowClick(row, column, event) {
      this.$emit("rowClick", row, column, event);
    },
    showActionTableDialog() {
      this.$emit("handelAction");
    },
    handleChangePage(val) {
      this.$emit("handleChangePage", val);
    },
    indexMethod(index) {
      return index * 1 + 1;
    },

    isEmpty() {
      this.$refs.mutipleTable.clearSelection();
    },

    checkboxInit(row, index) {
      if (this.dtatus == row.status) {
        return true;
      } else if (this.dtatus == "") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  /deep/.el-table {
    background-color: transparent;
    th {
      font-size: 14px;
      color: #fff;
      background-color: #2a548e;
      padding: 0;
      height: 40px;
    }
    tr {
      background-color: #081831;
    }
    tr:hover > td {
      background-color: #081831;
    }
    td {
      font-size: 13px;
      color: #fff;
      height: 35px;
      padding: 0;
      .el-tag {
        background-color: transparent;
        font-size: 13px;
        height: 24px;
        line-height: 24px;
        border: none !important;
      }
    }
    .el-button {
      background-color: transparent;
      border: none;
      border-radius: 0;
      color: #409eff;
      padding: 0;
    }
    .el-button.is-disabled,
    .el-button.is-disabled:focus,
    .el-button.is-disabled:hover {
      color: #c0c4cc;
    }
    .el-checkbox__inner {
      border-color: #697c97;
      background-color: transparent;
      border-radius: 0;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #409eff;
      border-color: #409eff;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #409eff;
    }

    .el-table__body tr.hover-row > td {
      background-color: transparent !important;
    }
  }
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #1b2943 !important;
  }
  /deep/.el-table__fixed-body-wrapper {
    // top: 40px !important;
  }
  .el-table::before {
    background-color: rgba(180, 185, 209, 0.15);
  }
  .el-table--border::after {
    background-color: rgba(180, 185, 209, 0.15);
  }
  /deep/.el-table__fixed-right::before {
    background-color: transparent;
  }
  /deep/.el-table--border {
    border-color: rgba(180, 185, 209, 0.15);
    th,
    td {
      border-bottom-color: rgba(180, 185, 209, 0.15);
      border-right-color: rgba(180, 185, 209, 0.15);
    }
  }
  /deep/.iconicon-chakanxq:before {
    color: #409eff;
  }
}
</style>
